import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ percentage }) => percentage}%;
  height: 5px;
  background: linear-gradient(to right, #08aeea 0%,#43cea2 100%);
  transition: all 0.4s ease-in-out;
`;

class ProgressBar extends Component {
  state = { val: null };

  render() {
    const { current, total } = this.props;
    let percentage = (current * 100) / total;
    if (percentage > 100) percentage = 100;
    return (
      <StyledProgressBar percentage={percentage}>{this.props.children}</StyledProgressBar>
    );
  }
}

ProgressBar.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
};

ProgressBar.defaultProps = {
  current: 0,
  total: 0,
};

export default ProgressBar;
